import services, { registerServices } from './serviceRegistry';

export { services };

export default {
  services,
  registerServices,
};
